export const Messages = {
  id: (id: number) => `API Key ID ${id}`,
  name: 'Name: ',
  error: 'Error: ',
};
